module.exports = __webpack_public_path__ + "static/media/SofiaProLightItalic.02d23a1a.otf";